<main class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <section hlmCard aria-labelledby="claim-title">
      <div hlmCardHeader>
        <h1 hlmCardTitle id="claim-title">Lege dein Passwort fest</h1>
        @if (info(); as i) {
          <p hlmCardDescription>
            <strong>{{ i.partner_name }}</strong> hat für
            <strong>{{ i.company_name || 'dein Geschäft' }}</strong> ein Schenkwerk-Konto angelegt.
            Das Konto gehört dir: Mit deinem eigenen Passwort meldest du dich künftig mit
            <strong>{{ i.email }}</strong> an.
          </p>
        }
      </div>

      <div hlmCardContent class="space-y-6">
        @if (loadingInfo()) {
          <div class="space-y-3" aria-busy="true" aria-label="Link wird geprüft">
            <hlm-skeleton class="h-10 w-full" />
            <hlm-skeleton class="h-10 w-full" />
            <hlm-skeleton class="h-10 w-full" />
          </div>
        } @else if (linkError()) {
          <div hlmAlert variant="destructive" role="alert">
            <ng-icon name="lucideTriangleAlert" />
            <p hlmAlertTitle>{{ linkError() }}</p>
            <p hlmAlertDescription>
              Hast du dein Passwort schon festgelegt?
              <a routerLink="/login" class="underline underline-offset-4">Zur Anmeldung</a>. Sonst
              schicken wir dir über
              <a routerLink="/forgot-password" class="underline underline-offset-4"
                >„Passwort vergessen“</a
              >
              einen neuen Link.
            </p>
          </div>
        } @else {
          <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-6" novalidate>
            <div hlmField>
              <label hlmFieldLabel for="claim-password">Passwort</label>
              <hlm-input-group class="w-full">
                <input
                  hlmInputGroupInput
                  id="claim-password"
                  [type]="showPassword() ? 'text' : 'password'"
                  formControlName="password"
                  autocomplete="new-password"
                  [attr.aria-invalid]="invalid('password') ? 'true' : null" />
                <hlm-input-group-addon align="inline-end">
                  <button
                    hlmInputGroupButton
                    type="button"
                    [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
                    (click)="showPassword.set(!showPassword())">
                    <ng-icon [name]="showPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                  </button>
                </hlm-input-group-addon>
              </hlm-input-group>
              <p hlmFieldDescription [class.text-destructive]="invalid('password')">
                Mindestens {{ minLength }} Zeichen.
              </p>
            </div>

            <div hlmField>
              <label hlmFieldLabel for="claim-confirm">Passwort bestätigen</label>
              <hlm-input-group class="w-full">
                <input
                  hlmInputGroupInput
                  id="claim-confirm"
                  [type]="showPassword() ? 'text' : 'password'"
                  formControlName="confirm"
                  autocomplete="new-password"
                  [attr.aria-invalid]="invalid('confirm') ? 'true' : null" />
              </hlm-input-group>
              @if (invalid('confirm')) {
                <p hlmFieldDescription class="text-destructive">
                  Die Passwörter stimmen nicht überein.
                </p>
              }
            </div>

            <div hlmField>
              <label class="flex cursor-pointer items-start gap-2">
                <hlm-checkbox
                  class="mt-0.5"
                  formControlName="acceptTerms"
                  aria-label="AGB und Datenschutzerklärung akzeptieren" />
                <span class="text-sm">
                  Ich habe die
                  <a
                    href="https://schenkwerk.com/agbs"
                    target="_blank"
                    rel="noopener"
                    class="underline underline-offset-4"
                    >AGB</a
                  >
                  sowie die
                  <a
                    href="https://schenkwerk.com/datenschutz"
                    target="_blank"
                    rel="noopener"
                    class="underline underline-offset-4"
                    >Datenschutzerklärung</a
                  >
                  gelesen und akzeptiere sie.
                </span>
              </label>
              @if (invalid('acceptTerms')) {
                <p hlmFieldDescription class="text-destructive">
                  Bitte akzeptiere die AGB und Datenschutzerklärung
                </p>
              }
            </div>

            @if (error()) {
              <div hlmAlert variant="destructive" role="alert">
                <ng-icon name="lucideTriangleAlert" />
                <p hlmAlertTitle>{{ error() }}</p>
              </div>
            }

            <button
              hlmBtn
              type="submit"
              class="w-full"
              [disabled]="loading()"
              [attr.aria-busy]="loading()">
              @if (loading()) {
                <hlm-spinner />
                Wird gespeichert…
              } @else {
                Passwort festlegen und anmelden
              }
            </button>

            <p hlmMuted class="text-center text-xs">
              {{ info()?.partner_name }} kann weiter in deinem Konto arbeiten. Das kannst du
              jederzeit in den Einstellungen unter „Deine Agentur“ beenden.
            </p>
          </form>
        }
      </div>
    </section>
  </div>
</main>
